export default () => ({
	notifications: [],
	notificationCount: 0,
	bind: {
		['@notification.window']() {
			const notification = {
				id: this.notificationCount,
				status: this.$event.detail.status,
				message: this.$event.detail.message,
				show: false,
			};
			this.notifications.push(notification);
			setTimeout(() => {
				const i = this.notifications.findIndex(
					({ id }) => id == notification.id
				);
				this.notifications[i].show = false;
				setTimeout(() => {
					const i = this.notifications.findIndex(
						({ id }) => id == notification.id
					);
					this.notifications.splice(i, 1);
				}, 200);
			}, 3000);
			this.notificationCount++;
			this.$nextTick(() => {
				const i = this.notifications.findIndex(
					({ id }) => id == notification.id
				);
				this.notifications[i].show = true;
			});
		},
	},
});
